export default {
  table: {
    tableClass: 'table table-striped mb-0',
    loadingClass: 'loading',
    ascendingIcon: 'fa fa-chevron-up',
    descendingIcon: 'fa fa-chevron-down',
    handleIcon: 'fas fa-bars',
    sortableIcon: 'fa fa-sort',
  },
  pagination: {
    wrapperClass: 'pagination pull-right',
    activeClass: 'active',
    disabledClass: 'disabled',
    pageClass: 'page-item',
    linkClass: 'page-link',
    icons: {
      first: '',
      prev: '',
      next: '',
      last: '',
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/app-table/css.config.js